import { faGear, faWindow, faFlag } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { APP_IDS, APP_NAMES } from "userful-chronos-app-common-js/dist/models/common";
import { getRootPath } from "userful-chronos-app-common-js/dist/routing";

const rootPath = getRootPath();
const locationSearch = typeof window === "undefined" ? "" : window.location.search;

export const AppConfig = {
    diamond: {
        name: APP_NAMES.ControlRoom,
        title: APP_NAMES.ControlRoom,
        titleIcon: <img alt="D" src="./assets/V2_icons/Decisions.png" />,
        url: rootPath + "decisions" + locationSearch,
        helpURI: "/diamond-control-room",
    },
    notifications: {
        name: APP_NAMES.Notification,
        title: APP_NAMES.Notification,
        titleIcon: <img alt="D" src="./assets/V2_icons/Notifications.png" />,
        url: rootPath + "notification" + locationSearch,
        helpURI: "/notifications",
        premium: true,
    },
    edgeAI: {
        name: APP_NAMES.EdgeAI,
        title: APP_NAMES.EdgeAI,
        titleIcon: <img alt="D" src="./assets/V2_icons/Eisenhower.png" />,
        url: rootPath + "edgeai" + locationSearch,
        helpURI: "/edgeai",
        premium: true,
    },
    carbon: {
        title: "Global Cluster Manager",
        titleIcon: <img alt="D" src="./assets/V2_icons/GCM.png" />,
        url: "",
    },
    controlManager: {
        title: "CommonUI.Applicationheaders.ControlManager",
        titleIcon: <img alt="D" src="./assets/controlRoom.svg" />,
        url: rootPath + "controlroommanager" + locationSearch,
    },
    emerald: {
        name: APP_NAMES.Engage,
        titleIcon: <img alt="E" src="./assets/V2_icons/Engage.png" />,
        url: rootPath + "engage" + locationSearch,
        helpURI: "/emerald-corporate-signage",
    },
    topaz: {
        name: APP_NAMES.Trends,
        titleIcon: <img alt="T" src="./assets/V2_icons/Trends.png" />,
        url: rootPath + "trends" + locationSearch,
        helpURI: "/topaz-business-intelligence",
    },
    amethyst: {
        name: APP_NAMES.Artistic,
        titleIcon: <img alt="A" src="./assets/amethyst.svg" />,
        url: rootPath + "artistic" + locationSearch,
        helpURI: "/amethyst-artistic",
    },
    sapphire: {
        name: APP_NAMES.Spaces,
        titleIcon: <img alt="S" src="./assets/V2_icons/Spaces.png" />,
        url: rootPath + "spaces" + locationSearch,
        helpURI: "/sappire-meeting-room",
    },
    ruby: {
        name: APP_NAMES.Remote,
        titleIcon: <img alt="R" src="./assets/V2_icons/OPStreams.png" />,
        url: rootPath + "opstreams" + locationSearch,
        helpURI: "/ruby-remote-worker",
    },
    config: {
        title: "CommonUI.Applicationheaders.Config",
        titleIcon: <img alt="uControl" src="./assets/V2_icons/System.png" />,
        //    titleIcon:( <img alt="config icon" src="./assets/gears.svg"/>),
        url: rootPath + "configuration" + locationSearch,
        helpURI: "/system-configuration",
    },
    monitoring: {
        title: "CommonUI.Applicationheaders.Monitoring",
        titleIcon: <img alt="R" src="./assets/V2_icons/MonitoringDashboard.png" />,
        url: rootPath + "monitoring" + locationSearch,
        helpURI: "/system-monitoring-dashboard",
    },
    sourcesAndDestinations: {
        title: "CommonUI.Applicationheaders.SourcesAndDestinations",
        titleIcon: <img alt="R" src="./assets/V2_icons/SourcesDestinations.png" />,
        url: rootPath + "source-destination-management" + locationSearch,
        helpURI: "/source-destination-configuration",
    },
    calibration: {
        title: "CommonUI.Applicationheaders.Calibration",
        titleIcon: <img alt="R" src="./assets/V2_icons/Decisions.png" />,
        url: rootPath + "videowall-calibration" + locationSearch,
        helpURI: "/calibration",
    },
    userManagement: {
        title: "CommonUI.Applicationheaders.UserManagement",
        titleIcon: <img alt="R" src="./assets/V2_icons/UserManager.png" />,
        url: rootPath + "usermanagement" + locationSearch,
        helpURI: "/usermanagement",
    },
    initialSetup: {
        title: "CommonUI.Applicationheaders.InitialSetup",
        titleIcon: <img alt="uControl" src="./assets/V2_icons/System.png" />,
        url: rootPath + "setup" + locationSearch,
        helpURI: "/initial-setup",
    },
    switch: {
        title: APP_NAMES.Switch,
        // titleIcon: <FontAwesomeIcon icon={faCodePullRequest} />,
        titleIcon: <img alt="uControl" src="./assets/V2_icons/uControl.png" />,
        url: rootPath + "ucontrol" + locationSearch,
        helpURI: "/ucontrol",
        premium: true,
    },
    uconduct: {
        title: "uConduct",
        titleIcon: <img alt="uConduct" src="./assets/V2_icons/uConduct.png" />,
        url: rootPath + "uconduct" + locationSearch,
        helpURI: "/uconduct",
        premium: true,
    },
    adminCenter: {
        title: "CommonUI.Applicationheaders.AdminCenter",
        titleIcon: <img alt="admin" src="./assets/V2_icons/Admin.png" />,
        url: rootPath + "admin" + locationSearch,
        helpURI: "/admin",
    },
    GCM: {
        title: "CommonUI.Applicationheaders.GCM",
        titleIcon: <img alt="Carbon" src="./assets/GMC.svg" />,
        url: rootPath + locationSearch,
        helpURI: "/carbon",
    },
    uClientDebuggingTool: {
        title: "uClient Debugging Tool",
        titleIcon: <FontAwesomeIcon icon={faWindow} />,
        url: rootPath + locationSearch,
        helpURI: "/",
    },
};

export const getPreviousAppFromAppID = (
    appIDValue,
): {
    title: string;
    titleIcon: any;
    url: string;
    helpURI: string;
} => {
    switch (appIDValue) {
        case "Calibration":
            return AppConfig.sourcesAndDestinations;
        case "Config":
        case "AetherManager":
        case "Monitoring":
            return AppConfig.adminCenter;

        default:
            return null;
    }
};

export const getAppFromAppID = (
    appIDValue,
): {
    title?: string;
    name?: string;
    titleIcon: any;
    premium?: boolean;
} => {
    switch (appIDValue) {
        case "uClientDebuggingTool":
            return AppConfig.uClientDebuggingTool;
        case "uConduct":
            return AppConfig.uconduct;
        case APP_IDS.Decisions:
        case "Diamond":
            return AppConfig.diamond;
        case "ControlRoomMgr":
            return AppConfig.controlManager;
        case APP_IDS.Notification:
            return AppConfig.notifications;
        case APP_IDS.EdgeAI:
            return AppConfig.edgeAI;
        case APP_IDS.Engage:
            return AppConfig.emerald;
        case APP_IDS.Trends:
            return AppConfig.topaz;
        case APP_IDS.Artistic:
            return AppConfig.amethyst;
        case APP_IDS.Spaces:
            return AppConfig.sapphire;
        case APP_IDS.Remote:
            return AppConfig.ruby;
        case "Config":
            return AppConfig.config;
        case "Calibration":
            return AppConfig.calibration;
        case "realm-management":
        case "AetherManager":
            return AppConfig.userManagement;
        case "Setup":
            return AppConfig.initialSetup;
        case "SourcesAndDestinations":
            return AppConfig.sourcesAndDestinations;
        case "Monitoring":
            return AppConfig.monitoring;
        case APP_NAMES.Switch:
            return AppConfig.switch;
        case "adminCenter":
            return AppConfig.adminCenter;
        case APP_IDS.GCM:
            return AppConfig.GCM;
        case APP_IDS.EdgeAI:
            return AppConfig.edgeAI;
        default:
            return null;
    }
};
